export default  {
    bindings: {
        closable: '<',
    },
    controller: 'basketPopupController',
    template: require('../views/basket.popup.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/popup/components/basket.popup.component.js